








































import { defineComponent,	PropType } from '@vue/composition-api';
import { UserGroupDetails } from '@front-app/services/CommunityApi/CommunityReportsApi';
import { UserRole } from '@front-app/services/UserApi/UserModel';

export default defineComponent({
	components: {},
	props: {
		groups: {
			type: Array as PropType<UserGroupDetails[]>,
			required: true,
		},
	},
	setup(props, ctx) {
		const GROUP_ROLE_LABELS: Record<UserRole, string> = {
			[UserRole.NONE]: 'none',
			[UserRole.DEPARTEE]: 'role_badge.departee',
			[UserRole.INVITEE]: 'role_badge.invitee',
			[UserRole.EXTERNAL_INVITEE]: 'role_badge.invitee',
			[UserRole.MEMBER]: 'role_badge.member',
			[UserRole.MODERATOR]: 'role_badge.moderator',
			[UserRole.ADMINISTRATOR]: 'role_badge.admin',
		};
		const getGroupRoleLabel = (groupRole: UserRole) => ctx.root.$t(GROUP_ROLE_LABELS[groupRole]);

		const getLastInviteDate = (group: UserGroupDetails) => {
			if (!group.lastInviteDate) {
				if (group.groupRole === UserRole.INVITEE) {
					return ctx.root.$t('csr.community-queries.no-invites');
				}
				return ctx.root.$t('csr.community-queries.no-date');
			}
			return ctx.root.$d(new Date(group.lastInviteDate), 'long');
		};

		const getJoinedDate = (group: UserGroupDetails) => {
			if (!group.joinedDate) {
				return ctx.root.$t('csr.community-queries.no-date');
			}
			return ctx.root.$d(new Date(group.joinedDate), 'long');
		};

		return {
			getGroupRoleLabel,
			getLastInviteDate,
			getJoinedDate,
		};
	},
});
